webpackJsonp([28618898628678],{

/***/ 371:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Church Services | Killasser Parish","author":"Kingluddite"}},"contentfulPastoralCouncil":{"title":"Pastoral Council","slug":"pastoral-council","metaDescription":"Pastoral Council of Killasser Parish Church","headerBackgroundImage":{"file":{"url":"//images.ctfassets.net/6rnd0h65xc7e/6NHL5TRbc4S0iOQGg8AkcS/6c2c78e4e7eb5a2a506867db4ce0e348/art-cathedral-christ-cropped.jpg"}},"sectionFourHeading":"Members","sectionFourContent":{"childMarkdownRemark":{"html":"<p>List of Pastoral Council Info and Members Placeholder</p>"}}}},"pathContext":{"slug":"/pastoral-council/","langKey":"en-US"}}

/***/ })

});


// WEBPACK FOOTER //
// path---pastoral-council-2eabcc6fc919d28e6e07.js